import { Box, Chip, Container, Typography } from "@material-ui/core";
import { IsMobile } from "utils/is-mobile";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import LoadingData from "components/Loading/LoadingData";
import { DESTAQUE_TABS } from "./constants";
import useFranchiseMarketing from "./hooks/use-franchise-marketing";
import useMarketingStyles from "./styles";
import HeroCarousel from "./components/hero-carousel";
import SectionHeader from "./components/section-header";
import { MarketingGrid } from "./components/marketing-card";
import PreviewDialog from "./components/preview-dialog";
import FiltersModal from "./components/filters-modal";
import {
  MarketingPageHeader,
  MarketingSearchBar,
} from "./components/marketing-toolbar";

const { primary, gray, stone, text } = themeColorsDesingSystem;

export default function FranchiseMarketingHome() {
  const classes = useMarketingStyles();
  const isMobile = IsMobile();

  const {
    loading,
    search,
    setSearch,
    filtersOpen,
    setFiltersOpen,
    destaqueTab,
    setDestaqueTab,
    showAllDestaques,
    destaquesFiltrados,
    previewItem,
    setPreviewItem,
    filters,
    setFilters,
    categoriasOptions,
    campanhasOptions,
    heroCampaigns,
    destaques,
    videos,
    materiaisRecentes,
    toggleFilterArray,
    clearFilters,
    handleViewCampaign,
    handleToggleShowAllDestaques,
    cardHandlers,
    snackbar,
  } = useFranchiseMarketing();

  if (loading) {
    return (
      <>
        <MarketingPageHeader />
        <Container maxWidth={false} className={classes.pageContent}>
          <LoadingData searching label="Carregando conteúdos de marketing..." />
        </Container>
      </>
    );
  }

  return (
    <>
      <MarketingPageHeader />

      <Container maxWidth={false} className={classes.pageContent}>
        <MarketingSearchBar
          search={search}
          onSearchChange={setSearch}
          onOpenFilters={() => setFiltersOpen(true)}
        />

        {heroCampaigns.length > 0 && (
          <HeroCarousel
            campaigns={heroCampaigns}
            onViewCampaign={handleViewCampaign}
          />
        )}

        <Box className={classes.section}>
          <SectionHeader
            title="Destaques"
            verTodosLabel={showAllDestaques ? "Ver menos" : "Ver todos"}
            onVerTodos={
              destaquesFiltrados.length > 3 ? handleToggleShowAllDestaques : null
            }
          />

          <Box
            display="flex"
            flexWrap="wrap"
            marginBottom={3}
            style={{ gap: 10 }}
          >
            {DESTAQUE_TABS.map((tab) => (
              <Chip
                key={tab.key}
                label={tab.label}
                clickable
                onClick={() => setDestaqueTab(tab.key)}
                className={classes.categoryChip}
                style={{
                  backgroundColor:
                    destaqueTab === tab.key ? primary.main : stone.light,
                  color: destaqueTab === tab.key ? "#fff" : text.primary,
                  fontWeight: destaqueTab === tab.key ? 600 : 500,
                }}
              />
            ))}
          </Box>

          {destaques.length ? (
            <MarketingGrid items={destaques} cardHandlers={cardHandlers} />
          ) : (
            <Box className={classes.emptyState}>
              <Typography variant="body2" style={{ color: gray.dark }}>
                Nenhum conteúdo encontrado para esta categoria.
              </Typography>
            </Box>
          )}
        </Box>

        {videos.length > 0 && (
          <Box className={classes.section}>
            <SectionHeader
              title="Vídeos"
              onVerTodos={() => setDestaqueTab("Video")}
            />
            <MarketingGrid
              items={videos}
              compact
              horizontal={isMobile}
              gridProps={{ xs: 12, sm: 6, md: 3 }}
              cardHandlers={cardHandlers}
            />
          </Box>
        )}

        {materiaisRecentes.length > 0 && (
          <Box className={classes.section}>
            <SectionHeader
              title="Materiais mais recentes"
              onVerTodos={() => setDestaqueTab("Material")}
            />
            <MarketingGrid
              items={materiaisRecentes}
              variant="file"
              cardHandlers={cardHandlers}
            />
          </Box>
        )}
      </Container>

      <FiltersModal
        open={filtersOpen}
        onClose={() => setFiltersOpen(false)}
        filters={filters}
        categoriasOptions={categoriasOptions}
        campanhasOptions={campanhasOptions}
        onToggleFilter={toggleFilterArray}
        onSetFilters={setFilters}
        onClearFilters={clearFilters}
      />

      <PreviewDialog
        item={previewItem}
        open={!!previewItem}
        onClose={() => setPreviewItem(null)}
      />
    </>
  );
}
